import { createContext, useState } from "react";

type LoadingContextType = {
   loading: boolean;
   setLoading: (value: boolean) => void;
};

const LoadingContext = createContext<LoadingContextType>({
   loading: false,
   setLoading: () => { }
})

const LoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
   const [loading, setLoading] = useState(false);

   return (
      <LoadingContext.Provider value={{ loading, setLoading }}>
         {children}
      </LoadingContext.Provider>
   );
};

// eslint-disable-next-line react-refresh/only-export-components -- co-located with its provider; splitting would ripple through every import site
export { LoadingContext }
export default LoadingProvider